import React, { useState } from 'react';
import './ProductCard.css';
import { useFavourites } from '../../context/FavouritesContext';

const TAG_COLORS = {
  NEW:     { bg: '#171717', color: '#fff' },
  LIMITED: { bg: '#da291c', color: '#fff' },
  SALE:    { bg: '#e8b400', color: '#171717' },
  HOT:     { bg: '#ff6b35', color: '#fff' },
};

export default function ProductCard({ product, onClick }) {
  const [imgIdx, setImgIdx] = useState(0);
  
  // New Global Favourites Logic
  const { isFavourited, toggleFavourite } = useFavourites();

  const tag = TAG_COLORS[product.tag];
  const isLiked = isFavourited(product.id);

  return (
    <div className="pc" onClick={onClick}>
      {/* Image area */}
      <div className="pc__img-wrap">
        <img
          src={product.images[imgIdx]}
          alt={product.name}
          className="pc__img"
        />

        {/* Tag badge */}
        {product.tag && (
          <span
            className="pc__tag"
            style={{ background: tag.bg, color: tag.color }}
          >
            {product.tag}
          </span>
        )}

        {/* Out of stock overlay */}
        {!product.inStock && (
          <div className="pc__oos">
            <span>Out of Stock</span>
          </div>
        )}

        {/* Updated Wishlist Button with Context */}
        <button
          className={`pc__heart${isLiked ? ' pc__heart--on' : ''}`}
          onClick={e => { e.stopPropagation(); toggleFavourite(product); }}
          aria-label="Wishlist"
        >
          <svg width="15" height="15" viewBox="0 0 24 24"
            fill={isLiked ? 'currentColor' : 'none'}
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
          </svg>
        </button>

        {/* Image dot nav */}
        {product.images.length > 1 && (
          <div className="pc__dots">
            {product.images.map((_, i) => (
              <button
                key={i}
                className={`pc__dot${i === imgIdx ? ' pc__dot--on' : ''}`}
                onClick={e => { e.stopPropagation(); setImgIdx(i); }}
              />
            ))}
          </div>
        )}

        {/* Quick view hover overlay */}
        <div className="pc__hover-overlay">
          <span className="pc__quick-view">QUICK VIEW</span>
        </div>
      </div>

      {/* Card footer */}
      <div className="pc__foot">
        <div className="pc__info">
          <p className="pc__brand">{product.brand}</p>
          <p className="pc__name">{product.name}</p>
          <p className="pc__colorway">{product.colorway}</p>
        </div>
        <div className="pc__pricing">
          {product.originalPrice && (
            <span className="pc__original">R {product.originalPrice.toLocaleString()}</span>
          )}
          <span className={`pc__price${product.originalPrice ? ' pc__price--sale' : ''}`}>
            R {product.price.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
}